// 999 -> 999
// 9999 -> 9,999
// 12270 -> 12,270
// 108700 -> 108,700
// 1580000 -> 1,580,000

export const formatNumToStandardNotation = (value: number) => {
  return Intl.NumberFormat('en-US', {
    notation: 'standard',
  }).format(value);
};
